"use strict";

$(document).ready(function () {
  var allPanels = $('.accordion > dd').hide();
  var allAccordions = $('.accordion > dt');
  $('.accordion > dt > a').click(function () {
    if (!$(this).parent().next().is(":visible")) {
      allPanels.slideUp().removeClass('active');
      allAccordions.removeClass('active');
      $(this).parent().addClass('active');
      $('.accordion small.right').html('&#9668;');
      $(this).find('small.right').html('&#9660;');
      $(this).parent().next().slideDown().addClass('active');
    }

    return false;
  });
  $($('.accordion dd')[0]).show().addClass('active');
  $($('.accordion dt')[0]).addClass('active');
});
$(document).ready(function () {
  function statsFunction() {
    // Target element to be observed.
    var observerElement = document.querySelector('#statistics');
    var animateResults = false; // Intersection Observer Configuration

    var observerOptions = {
      root: null,
      rootMargin: "0px 0px",
      // important: needs units on all values
      threshold: 0
    }; // Intersection Observer Constructor.

    var observer = new IntersectionObserver(handleIntersect, observerOptions); // Intersection Observer Callback Function

    function handleIntersect(entry) {
      // If intersecting.
      if (entry[0].intersectionRatio > 0) {
        if ($('#statistics').length) {
          if (animateResults === false) {
            $('.results article').each(function (index) {
              var value = $(this).find('span').first().data('number');
              $(this).find('span').first().countup(value);
            });
            animateResults = true;
          }
        }
      }
    }

    observer.observe(observerElement);
  }

  if ($('#statistics').length) {
    statsFunction();
  }
});
$(document).ready(function () {
  $('.services__top__service').on('click', function () {
    var block = $(this).data('link');
    var position = $('#' + block).offset();
    console.log(position);
    window.scrollTo({
      top: position.top,
      behavior: 'smooth'
    });
  });
});
$(document).ready(function () {
  var t = 0; // the height of the highest element (after the function runs)

  var t_elem; // the highest element (after the function runs)

  $(".tabbed-section__inner article").each(function () {
    var $this = $(this);

    if ($this.outerHeight() > t) {
      t_elem = this;
      t = $this.outerHeight();
    }

    $this.css('min-height', t);
  });
});